import React, { Component } from "react";
import { Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { DateRange } from "@material-ui/icons";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import UpdateContingencies from "./../Detail/UpdateContingenciesNew";
import PropTypes from "prop-types";
import validation from "react-validation-mixin";
import strategy from "joi-validation-strategy";
import { connect } from "react-redux";
import { getBuyerAgentMasterTemplateAction } from "./../../../actions/BuyerAgentMasterTemplateActions";
import * as message from "./../../../config/CommonMessages";

class AssignVendor extends Component {
  constructor(props) {
    super(props);

    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);

    this.state = {
      show: false,
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      activeContigency: true,
      inactiveContiClass: "",
      addVendor: false,
      campaignStyle: [],
      vendors: [],
      campContingencies: [],
      setVendors: [],
      showLoader: false,
      contacts: this.props.contacts,
    };
  }

  /**
   * @desc set start date and set contigency start date
   * @param {*} event
   * @param {*} picker
   */
  setStartDate(event, picker) {
    // console.log('in setStartDate');
    this.setState(
      {
        startDate: picker.startDate,
      },
      () => {
        this.props.updateTransactionData(
          "startDate",
          picker.startDate.format("YYYY-MM-DD")
        );
      }
    );

    let selectedcamp = this.props.getTransactionData().campaign;
    let camDays = 0;
    for (let i = 0, len = this.state.campaignStyle.length; i < len; i++) {
      let camp = this.state.campaignStyle[i];
      if (camp._id === selectedcamp) {
        camDays = camp.campaignDays;
      }
    }

    let edate = moment(this.state.startDate).subtract(-camDays, "days");

    let currentConti = this.state.campContingencies;
    let contingencies = [];

    currentConti.map((item, index) => {
      item.endDate = edate.format("YYYY-MM-DD");
      item.startDate = picker.startDate.format("YYYY-MM-DD");
      contingencies.push(item);
    });

    this.setState(
      {
        closeDate: edate,
        campContingencies: contingencies,
      },
      () => {
        this.props.updateTransactionData(
          "endDate",
          moment(edate).format("YYYY-MM-DD")
        );
        this.props.updateTransactionData("contingencies", contingencies);
      }
    );
  }

  /**
   * @desc set end date and set contigency end date
   * @param {*} event
   * @param {*} picker
   */
  setEndDate(event, picker) {
    // console.log('in setEndDate');
    this.setState({
      closeDate: picker.startDate,
    });

    let currentConti = this.state.campContingencies;
    let contingencies = [];

    currentConti.map((item, index) => {
      item.endDate = picker.startDate.format("YYYY-MM-DD");
      contingencies.push(item);
    });

    this.setState({ campContingencies: contingencies });

    this.props.updateTransactionData(
      "endDate",
      picker.startDate.format("YYYY-MM-DD")
    );
    this.props.updateTransactionData("contingencies", contingencies);
  }

  setModalOpen() {
    this.setState({ show: !this.state.show });
  }

  activeContigency(i) {
    if (i == 1) {
      this.setState({ activeContigency: !this.state.activeContigency });
      this.setState({ inactiveContiClass: "inactive" });
    }
    if (i == 2) {
      this.setState({ activeContigency: !this.state.activeContigency });
      this.setState({ inactiveContiClass: "" });
    }
  }

  addVendor() {
    this.setState({ addVendor: !this.state.addVendor });
  }

  componentDidMount() {
    // console.log('in componentDidMount');
    let draftedConti = this.props.getTransactionData().contingencies;
    let newDrafted = [];

    for (let i = 0; i < draftedConti.length; i++) {
      let con = draftedConti[i];
      if (con.val !== undefined) {
        newDrafted.push(con.val);
      } else {
        newDrafted.push(con);
      }
    }
    this.setState({
      showLoader: true,
      campContingencies: newDrafted,
    });
    //get buyer agent template
    this.props.getBuyerAgentMasterTemplateAction().then((res) => {
      this.setState({ campaignStyle: this.props.buyerMasterTemplates });

      let selectedcamp = "";
      let selectedUserCamp = null;
      let activeCampaign = null;
      let campContingencies = [];
      let campDays = 0;
      for (let i = 0, len = this.state.campaignStyle.length; i < len; i++) {
        let camp = this.state.campaignStyle[i];
        if (camp.system && camp.default !== undefined && camp.default) {
          activeCampaign = camp;
        } else if (!camp.system && camp.default !== undefined && camp.default) {
          selectedUserCamp = camp;
        }
      }
      if (selectedUserCamp !== null) {
        campContingencies = selectedUserCamp.contingencies;
        campDays = selectedUserCamp.campaignDays - 1;
        selectedcamp = selectedUserCamp._id;
      } else {
        campContingencies = activeCampaign.contingencies;
        campDays = activeCampaign.campaignDays - 1;
        selectedcamp = activeCampaign._id;
      }

      let vendors = this.state.setVendors;

      //set start date and end ddate
      let sdate = moment().add(1, "days");
      // let sdate = moment();
      let edate = moment().subtract(-campDays, "days");

      let contingencies = [];
      for (let key in campContingencies) {
        if (campContingencies.hasOwnProperty(key)) {
          let conti = campContingencies[key].name;
          let item = {
            name: campContingencies[key].name,
            startDate: sdate.format("YYYY-MM-DD"),
            endDate: edate.format("YYYY-MM-DD"),
            assignee: "",
            isParticipant: Boolean(campContingencies[key].isParticipant),
          };

          if (
            conti === message.CLOSING_AGENT ||
            conti === message.LISTING_AGENT ||
            conti === message.BUYER_AGENT
          ) {
            if (vendors[conti] !== undefined && vendors[conti] !== null) {
              let vendorsData =
                vendors[conti].data !== undefined &&
                vendors[conti].data !== null
                  ? vendors[conti].data
                  : [];
              for (let i = 0, len = vendorsData.length; i < len; i++) {
                if (vendorsData[i].default) {
                  item.assignee = vendorsData[i].contactId;
                }
              }
            }
          }
          contingencies.push(item);
        }
      }

      this.setState({ showLoader: false });

      if (!this.props.isDrafted) {
        if (!this.props.getTransactionData().contiChanged) {
          this.setState({
            startDate: sdate,
            closeDate: edate,
            campContingencies: contingencies,
          });
          this.props.updateTransactionData("campaign", selectedcamp);
          this.props.updateTransactionData("contingencies", contingencies);
          this.props.updateTransactionData(
            "startDate",
            moment(sdate).format("YYYY-MM-DD")
          );
          this.props.updateTransactionData(
            "endDate",
            moment(edate).format("YYYY-MM-DD")
          );
        }
      } else {
        this.setState({
          startDate: this.props.getTransactionData().startDate,
          closeDate: this.props.getTransactionData().endDate,
          campContingencies: draftedConti,
        });
      }
    });
  }

  updateTranConData(data) {
    // console.log('contiCamp data: ', data);
    this.setState({ campContingencies: data });
    this.props.updateTransactionData("contingencies", data);
    this.props.updateTransactionData("contiChanged", true);
  }

  /**
   * @desc set contigency for selected campaign
   * @param {*} e
   */
  setContingencyForCamp(e) {
    //set contingencies
    let selectedcamp = e.target.value;

    if (selectedcamp != "select") {
      let campContingencies = [];
      let campDays = 0;
      for (let i = 0, len = this.state.campaignStyle.length; i < len; i++) {
        let camp = this.state.campaignStyle[i];
        if (camp._id === selectedcamp) {
          campContingencies = camp.contingencies;
          campDays = camp.campaignDays - 1;
        }
      }

      let vendors = this.state.setVendors;

      //set start date and end ddate
      let sdate = moment();
      let edate = moment().subtract(-campDays, "days");

      let contingencies = [];
      for (let key in campContingencies) {
        if (campContingencies.hasOwnProperty(key)) {
          let conti = key;
          let item = {
            name: campContingencies[key].name,
            startDate: sdate.format("YYYY-MM-DD"),
            endDate: edate.format("YYYY-MM-DD"),
            assignee: "",
            isParticipant: Boolean(campContingencies[key].isParticipant),
          };

          if (
            conti === message.HOME_INSPECTION ||
            conti === message.RADON_INSPECTION ||
            conti === message.SEPTIC_INSPECTION ||
            conti === message.WOOD_DESTROYING_INSPECTION ||
            conti === message.FINANCING ||
            conti === message.LISTING_AGENT ||
            conti === message.CLOSING_AGENT ||
            conti === message.BUYER_AGENT
          ) {
            if (vendors[conti] !== undefined && vendors[conti] !== null) {
              let vendorsData =
                vendors[conti].data !== undefined &&
                vendors[conti].data !== null
                  ? vendors[conti].data
                  : [];
              for (let i = 0, len = vendorsData.length; i < len; i++) {
                if (vendorsData[i].default) {
                  item.assignee = vendorsData[i].contactId;
                }
              }
            }
          }
          contingencies.push(item);
        }
      }
      this.setState({
        startDate: sdate,
        closeDate: edate,
        campContingencies: contingencies,
      });
      this.props.updateTransactionData("campaign", selectedcamp);
      this.props.updateTransactionData("contingencies", contingencies);
      this.props.updateTransactionData(
        "startDate",
        moment(sdate).format("YYYY-MM-DD")
      );
      this.props.updateTransactionData(
        "endDate",
        moment(edate).format("YYYY-MM-DD")
      );
    } else {
      this.setState({ campContingencies: [] });
      this.props.updateTransactionData("campaign", "");
      this.props.updateTransactionData("contingencies", []);
    }
  }

  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  onChange(event) {
    if (
      event.target.name === "condo" ||
      event.target.name === "hoa" ||
      event.target.name === "builtBefore1978" ||
      event.target.name === "homeWarranty"
    ) {
      this.setState({ [event.target.name]: event.target.checked });
      this.props.updateTransactionData(event.target.name, event.target.checked);
    } else {
      this.setState({ [event.target.name]: event.target.value });
      this.props.updateTransactionData(event.target.name, event.target.value);
    }
  }

  //save as draft
  saveAsDraftStep2() {
    this.props.saveAsDraft(3);
  }

  render() {
    let campaignList = [];

    for (let i = 0, len = this.state.campaignStyle.length; i < len; i++) {
      let camp = this.state.campaignStyle[i];
      if (!camp.isDeleted) {
        let data = (
          <option key={camp._id} value={camp._id}>
            {camp.name}
          </option>
        );
        campaignList.push(data);
      }
    }

    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="admin-steps last-step admin-content-area campaign-step">
          <h2 className="color-blue-3 font-20">Select Campaign</h2>
          <div className="campaign-div">
            <Row>
              <Col xs={12} sm={10}>
                <form>
                  <Row>
                    <Col xs={12} sm={4}>
                      <Form.Group controlId="">
                        <Form.Label className="font-500 color-grey-1">
                          Campaign Style
                        </Form.Label>
                        <div className="c-select campaign-dropdown">
                          <select
                            name="campaign"
                            className="form-control"
                            onChange={(e) => this.setContingencyForCamp(e)}
                            value={this.props.getTransactionData().campaign}
                          >
                            <option value="select">Select</option>
                            {campaignList}
                          </select>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>

          <hr className="mt-1" />

          <UpdateContingencies
            isMasterTemplate={false}
            updateTransactionData={(k, v, isUp) =>
              this.props.updateTransactionData(k, v, isUp)
            }
            campContingencies={this.state.campContingencies}
            getTransactionData={() => this.props.getTransactionData()}
            contiCamp={(data) => this.updateTranConData(data)}
            setVendorsFun={(data) => {
              this.setState({ setVendors: data });
            }}
            isDrafted={this.props.isDrafted}
            campaignStyle={this.state.campaignStyle}
            contacts={this.state.contacts}
            isUpdateTrans={false}
          />
        </div>
      );
    }
  }
}

// export default AssignVendor;

AssignVendor.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  getTransactionData: PropTypes.func,
  updateTransactionData: PropTypes.func,
};

// var AssignVendor1 = validation(strategy)(AssignVendor);

const mapStateToProps = (state) => {
  return {
    buyerMasterTemplates: state.reducer.buyerMasterTemplates,
    totalBuyerTemplates: state.reducer.totalBuyerTemplates,
  };
};

export default validation(strategy)(
  connect(
    mapStateToProps,
    {
      getBuyerAgentMasterTemplateAction,
    }
  )(AssignVendor)
);
